export class RecruitInterview {
  constructor() {
    this.qanda = document.querySelectorAll('.p-interview-list__body');

    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    this.qanda.forEach((el) => {
      const moreButton = el.querySelector('.p-interview-list__more button');
      const moreContent = el.querySelector('.p-interview-list__content-wrapper');

      // Check if data-open attribute is set to true
      const isInitiallyOpen = moreButton.getAttribute('data-open') === 'true';
      moreButton.classList.toggle('is-open', isInitiallyOpen);
      moreContent.style.height = isInitiallyOpen ? `${moreContent.scrollHeight}px` : '0';
      moreButton.textContent = isInitiallyOpen ? '閉じる' : '開く';

      moreButton.addEventListener('click', () => {
        console.log('click');
        const isOpen = moreButton.classList.contains('is-open');
        moreButton.classList.toggle('is-open', !isOpen);
        moreContent.style.height = isOpen ? '0' : `${moreContent.scrollHeight}px`;

        // ボタンのテキストを更新
        moreButton.textContent = isOpen ? '開く' : '閉じる';
      });
    });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.qanda.forEach((el) => {
          const moreButton = el.querySelector('.p-interview-list__more button');
          const moreContent = el.querySelector('.p-interview-list__content-wrapper');
          if (moreButton.classList.contains('is-open')) {
            moreContent.style.height = `${moreContent.scrollHeight}px`;
          }
        });
      }, 500);
    }, { passive: true });
  }
}
